export interface CompanyFact {
  label: string;
  value: string; // '\n' で改行
  isAddress?: boolean;
}

export const COMPANY_FACTS: readonly CompanyFact[] = [
  { label: '会社名', value: '株式会社eNEW Studio' },
  { label: '設立', value: '令和7年（2025年）11月' },
  { label: '資本金', value: '200万円' },
  { label: '代表者', value: '代表取締役 伊原 健太' },
  {
    label: '所在地',
    value: '〒920-0849\n石川県金沢市堀川新町5番1号 アリマビル3F',
    isAddress: true,
  },
  {
    label: '事業内容',
    value:
      'クラウドソリューションの開発・提供\nAWS 再販・請求代行\nWeb システム開発\nDX 推進支援',
  },
];
